import { AloftPrice, DynamicScalar, isDefined, scalarToNumber } from '@aloft/toolkit-shared';

import _ from 'lodash';

export const scalarToNumberToString = (
  scalar: DynamicScalar | null | undefined,
): string | undefined =>
  isDefined(scalar)
    ? AloftPrice.isAloftPrice(scalar)
      ? scalar.toString(true, true)
      : scalarToNumber(scalar)?.toString()
    : undefined;

export function create2DCompsArray(compSequence: string[]) {
  const compSequenceCopy = _.cloneDeep(compSequence);
  const compSequence2dArray: string[][] = [];
  while (compSequenceCopy.length) compSequence2dArray.push(compSequenceCopy.splice(0, 3));

  return compSequence2dArray;
}
